import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { SendApiRequest } from 'src/api';
import { apiRoutes } from 'src/api/routes';
import { showToastAction } from '../ui';
import {
    fetchTimeTracker,
    timeTrackerFetched,
    timeTrackerFetchFailed,
    runTrackerAction,
    trackerActionFinished,
} from '../timeTracker';

// Body field the v1 tracker endpoints expect for each action's timestamp.
const ACTIONS = {
    start: {
        url: apiRoutes.timeTracker.start,
        timeKey: 'startTime',
        done: 'Shift started',
    },
    pause: {
        url: apiRoutes.timeTracker.pause,
        timeKey: 'pauseTime',
        done: 'Tracker paused',
    },
    resume: {
        url: apiRoutes.timeTracker.resume,
        timeKey: 'resumeTime',
        done: 'Tracker resumed',
    },
    stop: {
        url: apiRoutes.timeTracker.stop,
        timeKey: 'stopTime',
        done: 'Shift ended',
    },
};

function* fetchTimeTrackerEffect({ payload }) {
    try {
        // eslint-disable-next-line no-unused-vars
        const { silent, ...queryParams } = payload || {};
        const response = yield call(SendApiRequest, {
            url: apiRoutes.timeTracker.list,
            method: 'GET',
            queryParams,
        });
        yield put(timeTrackerFetched(response));
    } catch (e) {
        yield put(timeTrackerFetchFailed());
        yield put(
            showToastAction({
                type: 'danger',
                text: e?.message || 'Failed to load the time tracker',
            }),
        );
    }
}

function* runTrackerActionEffect({ payload }) {
    const { action, jobId, userId, time, onDone } = payload;
    const config = ACTIONS[action];
    try {
        yield call(SendApiRequest, {
            url: config.url,
            method: 'POST',
            body: { jobId, userId, [config.timeKey]: time },
        });
        yield put(showToastAction({ type: 'success', text: config.done }));
    } catch (e) {
        yield put(
            showToastAction({
                type: 'danger',
                text: e?.message || 'Tracker action failed',
            }),
        );
    } finally {
        yield put(trackerActionFinished({ jobId, userId }));
        // Refresh on failure too: the tracker may already have changed state
        // elsewhere (e.g. the contractor started it from the app).
        if (onDone) onDone();
    }
}

export const timeTrackerSagas = [
    takeLatest(fetchTimeTracker.type, fetchTimeTrackerEffect),
    takeEvery(runTrackerAction.type, runTrackerActionEffect),
];
